export default {
    props: {
        iconClass: {
            type: String,
            kComposite: 'iconClass'
        },
        name: {
            type: String,
            kComposite: 'name'
        },
        template: {
            type: String | Function,
            kComposite: 'template'
        },
        text: {
            type: String,
            kComposite: 'text'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridToolbar/Toolbar.js